import { createEnumFromArray } from '@cloud-wave/neon-common-lib';

const pageContentContainerTypes = ['FREE_FORM', 'CONTROLLED'] as const;

export type TPageType = (typeof pageContentContainerTypes)[number];

export const PageContentContainer = createEnumFromArray(pageContentContainerTypes);
